import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { disableGA, initGA } from "../../services/functions/googleAnalytics";
import React from "react";
;

export const CookieConsentBanner: React.FC = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      enableDeclineButton
      cookieName="analytics_consent"
      style={{ background: "#2B373B", zIndex: 9999, }}
      buttonStyle={{
        color: "#000",
        backgroundColor: "#A6C48A",
        fontSize: "13px",
        padding: "8px 16px",
        borderRadius: "14px",
      }}
      
      declineButtonStyle={{
        color: "#000",
        backgroundColor: "#FF6F61",
        fontSize: "13px",
        padding: "8px 16px",
        borderRadius: "14px",
      }}
      onAccept={() => {
        initGA();
      }}
      onDecline={() => {
        // optional: explicitly block future GA via gtag consent API:
        disableGA();
      }}
    >
      This site uses cookies for analytics.{" "}
      <span style={{ fontSize: "10px" }}>
        You can change your preference anytime in your profile.
      </span>
    </CookieConsent>
  );
};